import React from 'react';
import 'antd/dist/antd.css';
import './index.css';
import {ConfigProvider, InputNumber, Upload} from 'antd';
import esES from 'antd/lib/locale/es_ES';
import {
    Tag,
    List,
    DatePicker,
    Spin,
    Button,
    Layout,
    Breadcrumb,
    Table,
    Select,
    message,
    Divider,
    Tabs,
    Radio
} from 'antd';
import {Drawer, Form, Col, Row, Input} from 'antd';
import reqwest from 'reqwest';
import {useState} from 'react';
import {useEffect} from 'react';
import MyMenu from '../../components/Menu';
import {PlusOutlined, UploadOutlined} from '@ant-design/icons';
import {useHistory} from "react-router-dom";
import config from '../../config'

//import GooglePlacesAutocomplete from 'react-google-places-autocomplete';
import {GoogleMap, LoadScript, Autocomplete, Marker} from '@react-google-maps/api';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import {catchErrors, getToken} from '../../Utils/common';

import Moment from 'moment';
import {extendMoment} from 'moment-range';
import 'moment/locale/es';
import axios from "axios";

const moment = extendMoment(Moment);
moment.locale('es');

const {Option} = Select;
const {Content, Sider, Header} = Layout;
const {Search} = Input;
const {TabPane} = Tabs;

const os = ['OSDE', 'Swiss Medical', 'PAMI'];

const columns = [
    {
        title: 'Estado',
        dataIndex: 'status',
    },
    {
        title: 'Nombre',
        dataIndex: 'name',
        sorter: true,
        width: '20%',
    },
    {
        title: 'Apellido',
        dataIndex: 'last_name',
        sorter: true,
        width: '20%',
    },
    {
        title: 'Especialidad',
        dataIndex: 'speciality',
    },
    {
        title: 'Matrícula',
        dataIndex: 'matricula',
    },
    {
        title: 'Email',
        dataIndex: 'email',
    },
    {
        title: 'Teléfono',
        dataIndex: 'phone',
    },
    {
        title: 'Usuario',
        dataIndex: 'user_username',
    },
];

function getAddressObject(address_components) {
    var ShouldBeComponent = {
        home: ["street_number"],
        postal_code: ["postal_code"],
        street: ["street_address", "route"],
        city: [
            "administrative_area_level_1",
        ],
        comuna: [
            "administrative_area_level_2",
        ],
        locality: [
            "locality",
        ],
        neighborhood: [
            "sublocality",
            "sublocality_level_1",
            "sublocality_level_2",
            "sublocality_level_3",
            "sublocality_level_4"
        ],
        country: ["country"]
    };

    var address = {
        home: "",
        postal_code: "",
        street: "",
        region: "",
        city: "",
        country: ""
    };
    address_components.forEach(component => {
        for (var shouldBe in ShouldBeComponent) {
            if (ShouldBeComponent[shouldBe].indexOf(component.types[0]) !== -1) {
                if (shouldBe === "country") {
                    address[shouldBe] = component.short_name;
                } else {
                    address[shouldBe] = component.long_name;
                }
            }
        }
    });
    return address;
}

function Profesionals() {
    const history = useHistory();

    const defaultCenter = {
        lat: -34.6037, lng: -58.3816
    }
    const [expand, setExpand] = useState(true);
    const [treatmentProfesionalAppointment, setTreatmentProfesionalAppointment] = useState();

    const [data, setData] = useState([]);
    const [appointmentsData, setAppointmentsData] = useState([]);

    const [spinning, setSpinning] = useState(false);
    const [place, setPlace] = useState({});
    const [filters, setFilters] = useState('&search=');
    const [currentPosition, setCurrentPosition] = useState(defaultCenter);
    const [zoom, setZoom] = useState(12)
    const [pagination, setPagination] = useState({
        current: 1,
        pageSize: 10,
    });
    const [loading, setLoading] = useState(false);
    const [loadingList, setLoadingList] = useState(false);
    const [loadingSaveButton, setLoadingSaveButton] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const [visible, setVisible] = useState();
    const [visibleSearch, setVisibleSearch] = useState(false);
    const [visibleAppointment, setVisibleAppointment] = useState(false);
    const [disabled, setDisabled] = useState(true);
    const [showDestroyedFields, setShowDestroyedFields] = useState(false);
    const [showPsychiatryFields, setShowPsychiatryFields] = useState(false);
    const [showPsychologyFields, setShowPsychologyFields] = useState(false);
    const [showClinicFields, setShowClinicFields] = useState(false);
    const [showAdmisorFields, setShowAdmisorFields] = useState(false);
    const [active, setActive] = useState(0);
    const [formData, setFormData] = useState({});
    const [childrenDrawer, setChildrenDrawer] = useState(false);
    const [useMap, setUseMap] = useState(false);
    const [form] = Form.useForm();
    const [searchform] = Form.useForm();
    const [appointmentform] = Form.useForm();
    const [formMaps] = Form.useForm();
    const [autocomplete, setAutocomplete] = useState(null);
    const [profesionals, setProfesionals] = useState([]);
    const [admisors, setAdmisors] = useState([]);
    const [fetchingProfesionals, setFetchingProfesionals] = useState(false);
    const [fetchingAdmisors, setFetchingAdmisors] = useState(false);
    const [admisorSelected, setAdmisorSelected] = useState([])
    const [profesionalSelected, setProfesionalSelected] = useState([])
    const [slotsTaken, setSlotsTaken] = useState([])
    const [profesionalWorkingHours, setProfesionalWorkingHours] = useState([])
    const [pacientAppointments, setPacientAppointments] = useState([])
    const [disbleUpload, setDisableUpload] = useState(true)
    // Users for linking system user to profesional
    const [users, setUsers] = useState([])
    const [fetchingUsers, setFetchingUsers] = useState(false)
    // Controla el remount del formulario para evitar que "herede" valores entre profesionales
    const [currentProfId, setCurrentProfId] = useState(null)


    const fetchProfesionals = (params = {}) => {
        setFetchingProfesionals(true);
        setFetchingAdmisors(true);
        setProfesionals([]);

        if (params)
            params = `?search=${params}`

        reqwest({
            url: `${config.api_url}/profesionals/${params}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(data => {
                console.log("PARAMS IN FETCH");
                console.log(params);


                console.log(data);
                setFetchingProfesionals(false);
                const profesionals_data = data.results.map(user => ({
                    text: `${user.name} ${user.last_name}`,
                    value: user.id,
                }));
                console.log("profesionals_data")
                console.log(profesionals_data);

                setProfesionals(profesionals_data);

            }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const fetchAdmisors = (params = {}) => {
        setFetchingAdmisors(true);
        setAdmisors([]);

        if (params)
            params = `?search=${params}`

        reqwest({
            url: `${config.api_url}/profesionals/?admisor=true`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        })
            .then(data => {
                console.log("PARAMS IN FETCH");
                console.log(params);


                console.log(data);
                setFetchingAdmisors(false);
                const admisors_data = data.results.map(user => ({
                    text: `${user.name} ${user.last_name}`,
                    value: user.id,
                }));
                console.log("admisors_data")
                console.log(admisors_data);

                setAdmisors(admisors_data);

            }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los admisores.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const mapStyles = {
        height: "80vh",
        width: "100%"
    };

    const onLoad = (autocomplete_instance) => {
        console.log("Loaded autocomplete");
        if (autocomplete === null) {
            setAutocomplete(autocomplete_instance)
            setCurrentPosition(defaultCenter)
        }
    }

    const onPlaceChanged = () => {
        // setPlace( () => autocomplete.getPlace())
        const place = autocomplete.getPlace();
        setDisabled(false);
        setCurrentPosition({'lat': place.geometry.location.lat(), 'lng': place.geometry.location.lng()});
        setZoom(18)
    }

    useEffect(() => {
        fetch({'pagination': pagination, 'filters': filters})
        fetchProfesionals("")
        fetchAdmisors("")
        fetchUsers("")
    }, []);

    const fetchUsers = (search = '') => {
        setFetchingUsers(true);
        let url = `${config.api_url}/users/`;
        if (search) {
            url += `?search=${encodeURIComponent(search)}`;
        }
        reqwest({
            url: url,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            const options = (data.results || data).map(u => ({
                text: `${u.username}${(u.first_name || u.last_name) ? ' - ' : ''}${u.first_name || ''} ${u.last_name || ''}`.trim(),
                value: u.id,
            }));
            setUsers(options);
            setFetchingUsers(false);
        }).catch((errorInfo) => {
            setFetchingUsers(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else {
                message.error(`Error al obtener usuarios.
Status: ${errorInfo.status}
Detalle: ${errorInfo.responseText}`);
            }
        });
    };

    function onClose() {
        console.log("Closing drawer");
        try { form.resetFields(); } catch (e) {}
        setCurrentProfId(null)
        setVisible(false);
    }

    function onCloseSearch() {
        console.log("Closing search drawer");
        setVisibleSearch(false);
    }

    function onCloseAppointment() {
        console.log("Closing appointment drawer");
        setVisibleAppointment(false);
    }

    function onSave() {
        console.log("Saving data in drawer");
        console.log(form.getFieldsValue());
        form.validateFields()
            .then(
                values => {
                    update_pacient(form.getFieldsValue());
                }
            ).catch(
            errorInfo => {
                console.log(errorInfo);
            }
        );
    }


    const fetch = (params = {}) => {
        // this.setState({ loading: true });
        setLoading(true);
        setActive(9);

        let offset = '';
        if (params.pagination.current > 1) {
            //offset = `&offset=${params.pagination.current - 1 + 10}`
            console.log(params.pagination)
            offset = `&offset=${pagination.pageSize * (params.pagination.current - 1)}`
        }

        let direction = "";
        let order = "";
        if (params.sortField) {
            if (params.sortOrder === "descend")
                direction = "-";
            order = `&ordering=${direction}${params.sortField}`;
        }

        reqwest({
            url: `${config.api_url}/profesionals/?limit=${params.pagination.pageSize}${offset}${params.filters}${order}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            console.log("PARAMS IN FETCH");
            console.log(params);


            console.log(data);
            setLoading(false);
            setData(data.results);
            setPagination({
                'total': data.count,
                'current': params.pagination.current,
                'pageSize': params.pagination.pageSize
            })
            console.log(pagination);

        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los profesionales.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const fetch_by_id = (id = {}) => {
        setLoading(true);
        setSpinning(true);
        // this.setState({ loading: true });
        reqwest({
            url: config.api_url + '/profesionals/' + id,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            console.log(data);
            setVisible(true);
            setLoading(false);
            setSpinning(false);

            // Asegurar que el formulario esté limpio para este registro y fijar la clave de remount
            try { form.resetFields(); } catch (e) {}
            setCurrentProfId(data.id || null)
            form.setFieldsValue(data);

            // Asegurar que el usuario actual esté en las opciones del Select
            if (data.user && data.user_username) {
                const exists = users.some(u => u.value === data.user);
                if (!exists) {
                    setUsers(prev => ([...prev, { value: data.user, text: `${data.user_username}` }]));
                }
                // Setear explícitamente el valor del Select una vez asegurada la opción
                form.setFieldsValue({ user: data.user })
            } else {
                form.setFieldsValue({ user: null })
            }
            if (data.status === "B") {
                setShowDestroyedFields(true);
            } else {
                setShowDestroyedFields(false);
            }

            if (data.psychiatry_treatment_status === "A") {
                setShowPsychiatryFields(true);
            } else {
                setShowPsychiatryFields(false);
            }

            if (data.psychology_treatment_status === "A") {
                setShowPsychologyFields(true);
            } else {
                setShowPsychologyFields(false);
            }

            if (data.admision_treatment_status === "A") {
                setShowAdmisorFields(true);
            } else {
                setShowAdmisorFields(false);
            }

            if (data.clinic_status === "A") {
                setShowClinicFields(true);
            } else {
                setShowClinicFields(false);
            }
        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener el paciente.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
        ;
    };

    const update_pacient = (pacient = {}) => {
        setLoadingSaveButton(true);
        let url = "";
        let method = "";

        // Normalizar user: undefined -> null (desasignar)
        if (typeof pacient.user === 'undefined') {
            pacient.user = null;
        }

        if (pacient.id > 0) {
            url = config.api_url + '/profesionals/' + pacient.id + '/';
            method = 'patch';
        } else {
            url = config.api_url + '/profesionals/';
            method = 'post';
        }
        reqwest({
            url: url,
            method: method,
            type: 'json',
            contentType: 'application/json',
            data: JSON.stringify(pacient),
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setLoadingSaveButton(false);
            message.success("Actualizacion correcta")
            fetch({pagination, 'filters': filters})
        })
            .catch(
                errorInfo => {
                    if (errorInfo.status == 401) {
                        sessionStorage.removeItem('token');
                        sessionStorage.removeItem('user');
                        history.push('/login');
                    } else {
                        setLoadingSaveButton(false);
                        console.log(errorInfo);
                        let error_detail_txt = "";
                        try {
                            const error_detail_obj = JSON.parse(errorInfo.responseText);
                            Object.entries(error_detail_obj).forEach(([k, v]) => {
                                console.log(k);
                                error_detail_txt = `${error_detail_txt}${k}\n`;
                                // v can be an array, string, or object depending on backend error format
                                if (Array.isArray(v)) {
                                    v.forEach((value) => {
                                        error_detail_txt = `${error_detail_txt}(${value})\n`;
                                        console.log(value);
                                    });
                                } else if (v && typeof v === 'object') {
                                    Object.values(v).forEach((value) => {
                                        error_detail_txt = `${error_detail_txt}(${value})\n`;
                                        console.log(value);
                                    });
                                } else {
                                    error_detail_txt = `${error_detail_txt}(${v})\n`;
                                    console.log(v);
                                }
                                error_detail_txt = `${error_detail_txt}\n`;
                            });
                        } catch (e) {
                            // Fallback to raw response text if not JSON
                            error_detail_txt = errorInfo.responseText || "";
                        }
                        // Mensaje amigable si es conflicto por OneToOne
                        if (error_detail_txt.toLowerCase().includes('unique') || error_detail_txt.toLowerCase().includes('one-to-one')) {
                            message.error('El usuario seleccionado ya está asignado a otro profesional.');
                        }
                        message.error(`Ha ocurrido un error al intentar guardar el profesional.\nStatus: ${errorInfo.status}\nDetalle: ${error_detail_txt}`);
                    }
                }
            );
    };


    const handleTableChange = (pagination, filters, sorter) => {
        console.log("PAGINATION ON CHANGE");

        console.log(pagination);
        console.log(filters);

        fetch({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            'filters': '', // TODO: get value from search input
        });
    };

    const showDrawer = (user_id = 0) => {
        // Limpiar cualquier valor previo del formulario para evitar que "herede" datos del último profesional abierto
        try { form.resetFields(); } catch (e) {}
        setCurrentProfId(user_id)
        setDisableUpload(false)
        fetch_by_id(user_id);
    }

    const showDrawerCreate = () => {
        try { form.resetFields(); } catch (e) {}
        setCurrentProfId('new')
        // Inicializamos valores por defecto del form al crear
        form.setFieldsValue({ user: null })
        setDisableUpload(true)
        setVisible(true);
    }

    const showDrawerSearch = () => {
        setVisibleSearch(true);
    }

    const showDrawerAppointment = (prof) => {
        setVisibleAppointment(true);
        setTreatmentProfesionalAppointment(prof)
    }

    const showChildrenDrawer = () => {
        setChildrenDrawer(true);
    }

    const onChildrenDrawerClose = () => {
        // If user cancels without selecting an address (Confirm disabled), turn off map mode to prevent auto-reopen
        if (useMap && disabled) {
            setUseMap(false);
        }
        setChildrenDrawer(false);
    }


    const showStates = () => {
        console.log("");
    }

    const onCollapse = collapsed => {
        console.log(collapsed);
        setCollapsed((prevCollapsed) => {
            return !prevCollapsed
        });
    };


    const onStatuChange = status => {
        console.log("Status " + status);
        form.setFieldsValue({'destroyed_cause': '', 'file_location': ''});
        if (status === "B") {
            setShowDestroyedFields(true);
        } else {
            setShowDestroyedFields(false);
        }

    }

    const buildAddr = (addr_obj) => {
        let addr = `${addr_obj.street} ${addr_obj.home}`

        if (addr_obj.neighborhood) {
            addr = `${addr}, ${addr_obj.neighborhood}`
        }

        if (addr_obj.locality) {
            addr = `${addr}, ${addr_obj.locality}`
        }

        if (addr_obj.city) {
            addr = `${addr}, ${addr_obj.city}`
        }

        return addr;
    }

    const onConfirmAddress = () => {
        console.log("Confirmed addr");
        const place = autocomplete.getPlace()
        console.log(place.address_components);
        const addr_obj = getAddressObject(place.address_components);
        const addr = buildAddr(addr_obj);
        form.setFieldsValue({"address": `${addr}`})

        if (addr_obj.comuna) {
            form.setFieldsValue({"comuna": addr_obj.comuna})
        }

        message.success("Domicilio confirmado");
        setDisabled(true);
        setChildrenDrawer(false);
    }

    const handleOnChangeProfesional = value => {
        // setProfesionals([])
        setFetchingProfesionals(false)
        console.log("Selected profesional");
        console.log(value);

        setProfesionalSelected(value);
    }

    const handleOnChangeAdmisor = value => {
        setFetchingAdmisors(false)
        console.log("Selected profesional");
        console.log(value);

        setAdmisorSelected(value);
    }

    const onAdmisorStatusChange = status => {
        form.setFieldsValue({'total_admisor_sessions': '', 'current_admisor_sessions': ''});
        if (status === "A") {
            setShowAdmisorFields(true);
        } else {
            setShowAdmisorFields(false);
        }
    }

    const onPsychologyStatusChange = status => {
        form.setFieldsValue({'total_psychology_sessions': '', 'current_psychology_sessions': ''});
        if (status === "A") {
            setShowPsychologyFields(true);
        } else {
            setShowPsychologyFields(false);
        }
    }

    const onPsychiatryStatusChange = status => {
        form.setFieldsValue({'total_psychiatry_sessions': '', 'current_psychiatry_sessions': ''});
        if (status === "A") {
            setShowPsychiatryFields(true);
        } else {
            setShowPsychiatryFields(false);
        }
    }

    const onClinicStatusChange = status => {
        if (status === "A") {
            setShowClinicFields(true);
        } else {
            setShowClinicFields(false);
        }
    }

    const onFastSearch = (value) => {
        console.log('fast search button ' + value);
        fetch({
            pagination,
            'filters': `&search=${value}`,
        });
    }
    const onSearch = (value) => {

        let filters = searchform.getFieldsValue();
        let s = "";
        if (filters['profesional']) {
            filters['psychiatry_treatment_profesional__last_name'] = filters['profesional'];
            filters['psychology_treatment_profesional__last_name'] = filters['profesional'];
        }
        console.log(filters);
        /*filters.forEach( (value, key) =>{
          if (value){
            s = `${s}&${key}=${value}`;
          }
        })*/
        if (filters['psychiatry_treatment_modality']) {
            s = `${s}&psychiatry_treatment_modality=${filters['psychiatry_treatment_modality']}`;
        }
        if (filters['psychology_treatment_modality']) {
            s = `${s}&psychology_treatment_modality=${filters['psychology_treatment_modality']}`;
        }
        if (filters['comuna']) {
            s = `${s}&comuna=Comuna ${filters['comuna']}`;
        }
        if (filters['pacient_type']) {
            s = `${s}&pacient_type=${filters['pacient_type']}`;
        }
        if (filters['psychiatry_treatment_profesional']) {
            s = `${s}&psychiatry_treatment_profesional=${filters['psychiatry_treatment_profesional']}`;
        }
        if (filters['psychology_treatment_profesional']) {
            s = `${s}&psychology_treatment_profesional=${filters['psychology_treatment_profesional']}`;
        }
        console.log('search button ' + s);
        fetch({
            pagination,
            'filters': s,
        });
    }


    const onSearchAppointment = (value) => {

        let in_days = appointmentform.getFieldValue('appointment_days')
        if (!in_days) {
            console.log("No estaba seteado");
            appointmentform.setFieldsValue({appointment_days: 0})
        }

        if (value === 'next') {
            appointmentform.setFieldsValue({appointment_days: appointmentform.getFieldValue('appointment_days') + 7})
        } else if (value === 'previous') {
            if (in_days <= 0) {
                appointmentform.setFieldsValue({appointment_days: 0})
            } else {
                appointmentform.setFieldsValue({appointment_days: appointmentform.getFieldValue('appointment_days') - 7})
            }
        }

        let search_filters = appointmentform.getFieldsValue();

        console.log(search_filters);

        let filters = {}

        let start_date_filter = null;
        let end_date_filter = null;
        if (!search_filters.appointment_days) {
            start_date_filter = moment(search_filters.appointment_range)
            end_date_filter = moment(search_filters.appointment_range)
        } else {
            console.log("desde " + search_filters.appointment_days);

            start_date_filter = moment(search_filters.appointment_range).add(search_filters.appointment_days, 'days')
            end_date_filter = moment(search_filters.appointment_range).add(search_filters.appointment_days, 'days')
        }

        console.log(start_date_filter);
        filters['appointment_start'] = start_date_filter.startOf('week').format('YYYY-MM-DD 00:00');
        filters['appointment_end'] = end_date_filter.endOf('week').format('YYYY-MM-DD 23:59');


        //filters['pacient_profesional'] = form.getFieldValue('psychiatry_treatment_profesional');
        filters['pacient_profesional'] = form.getFieldValue(treatmentProfesionalAppointment);


        console.log("Range");


        // s = `${s}&profesional=${pacient_profesional}&appointment_start=${moment(filters.appointment_range[0]._d).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(filters.appointment_range[1]._d).format('YYYY-MM-DD 23:59')}`;


        console.log(filters);
        // console.log('search appointments button ' + s);
        fetchAppointments({
            pagination,
            'filters': filters,
        });
    }

    const handleNewAppointment = (fecha, hora, modality) => {
        console.log("Nuevo turno solicitado para " + fecha + hora);
        console.log(form.getFieldValue(treatmentProfesionalAppointment));
        console.log(form.getFieldValue("id"));

        // TODO fix gmt -3
        console.log(`${fecha}T${hora}:00`);
        const fecha_turno = moment(`${fecha} ${hora}:00`).add(3, "hours").format('YYYY-MM-DDTHH:mm:ss')
        console.log(fecha_turno);

        let is_admision = false;
        if (treatmentProfesionalAppointment === 'admision_treatment_profesional') {
            is_admision = true;
        }

        const params = {
            // TODO: fix utc
            appointment_at: fecha_turno,
            pacient: form.getFieldValue("id"),
            profesional: form.getFieldValue(treatmentProfesionalAppointment),
            is_admision: is_admision,
            modality: modality,
        }
        fetchCreateAppointments(params)
    }

    const fetchCreateAppointments = (params) => {
        setLoadingList(true)
        reqwest({
            url: `${config.api_url}/appointments/`,
            method: 'post',
            type: 'json',
            data: params,
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            console.log(data)
            const s = [...slotsTaken, data]
            setSlotsTaken(s)
            //setLoadingList(false)
            onSearchAppointment()
        }).catch((errorInfo) => {
            setLoadingList(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar crear el turno.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const handleDeleteAppointment = (id, tag_id) => {

        const params = {
            id: id,
            tag_id: tag_id
        }
        fetchDeleteAppointments(params)
    }

    const fetchDeleteAppointments = (params) => {
        setLoadingList(true)
        reqwest({
            url: `${config.api_url}/appointments/${params.id}`,
            method: 'delete',
            type: 'json',
        }).then(data => {
            console.log(data)
            let s = [...slotsTaken]
            s.splice(params.tag_id, 1)
            setSlotsTaken(s)
            setLoadingList(false)
            onSearchAppointment()
        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar eliminar el turno.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };

    const get_profesional_working_hours = (profesional_id) => {
        console.log("Getting working hours");
        console.log(profesional_id);

        reqwest({
            url: `${config.api_url}/profesionalworkingdays/?profesional_id=${profesional_id}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            setProfesionalWorkingHours(() => data.results);
        })
    }


    const fetchPacientAppointments = (pacient_id = null) => {
        reqwest({
            url: `${config.api_url}/appointments/?profesional_id=${pacient_id}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            console.log(data);
            setPacientAppointments(data.results);
        });
    }

    const fetchAppointments = (params = {}) => {
        setLoadingList(true);

        let offset = '';
        if (params.pagination.current > 1)
            offset = `&offset=${params.pagination.current - 1}`

        let direction = "";
        let order = "";
        if (params.sortField) {
            if (params.sortOrder === "descend")
                direction = "-";
            order = `&ordering=${direction}${params.sortField}`;
        }
        order = '&ordering=appointment_at'

        const filter_query = `&profesional=${params.filters.pacient_profesional}&appointment_start=${moment(params.filters.appointment_start).format('YYYY-MM-DD 00:00')}&appointment_end=${moment(params.filters.appointment_end).format('YYYY-MM-DD 23:59')}`;


        reqwest({
            url: `${config.api_url}/appointments/?limit=${params.pagination.pageSize}${offset}${filter_query}${order}`,
            method: 'get',
            type: 'json',
            headers: {
                'Authorization': `Token ${getToken()}`,
            }
        }).then(data => {
            console.log(moment(params.filters.appointment_start).format('dd'))

            // range to show
            let range = moment.range(params.filters.appointment_start, params.filters.appointment_end)

            get_profesional_working_hours(params.filters.pacient_profesional);
            console.log("profesional hours");


            //Grid
            let working_hours_table = {'lu': {}, 'ma': {}, 'mi': {}, 'ju': {}, 'vi': {}}
            profesionalWorkingHours.forEach((val, ind, arr) => {
                console.log("diff");
                console.log(val.hour_from);
                console.log(val.hour_to);
                console.log(moment(val.hour_to, "HH:mm:ss").diff(moment(val.hour_from, "HH:mm:ss"), 'hours'))
                let hours_diff = moment(val.hour_to, "HH:mm:ss").diff(moment(val.hour_from, "HH:mm:ss"), 'hours')
                let hour_from = moment(val.hour_from, "HH:mm:ss")
                let intervals_iterations = 2
                let intervals_minutes = 30
                if (val.over_shifts) {
                    intervals_iterations = 3
                    intervals_minutes = 15
                }

                for (let hour = 0; hour < hours_diff * intervals_iterations + 1; hour++) {
                    //console.log("hour from!!");
                    console.log(hour_from.format("HH:mm"))
                    working_hours_table[val.day_name][hour_from.format("HH:mm")] = []
                    working_hours_table[val.day_name][hour_from.format("HH:mm")].push(val.modality)
                    hour_from.add(intervals_minutes, 'minutes')
                }
            })

            console.log(working_hours_table)

            let all_appointments = []
            for (let day of range.by('day')) {

                let f = day.locale('es').format('YYYY-MM-DD')
                console.log(day.format('dd'));
                console.log(working_hours_table);

                all_appointments.push({[f]: working_hours_table[day.format('dd')]})
                /*all_appointments.push( { [f]: [
                  { appointment_at: '09:00', appointments: [] },
                  { appointment_at: '09:15', appointments: [] },
                  { appointment_at: '09:30', appointments: [] },
                  { appointment_at: '09:45', appointments: [] },
                  { appointment_at: '10:00', appointments: [] },
                  { appointment_at: '10:15', appointments: [] },
                  { appointment_at: '10:30', appointments: [] },
                  { appointment_at: '10:45', appointments: [] },
                  { appointment_at: '11:00', appointments: [] },
                  { appointment_at: '11:15', appointments: [] },
                  { appointment_at: '11:30', appointments: [] },
                  { appointment_at: '11:45', appointments: [] },
                  { appointment_at: '12:00', appointments: [] },
                  { appointment_at: '12:15', appointments: [] },
                  { appointment_at: '12:30', appointments: [] },
                  { appointment_at: '12:45', appointments: [] },
                  { appointment_at: '13:00', appointments: [] },
                  { appointment_at: '13:15', appointments: [] },
                  { appointment_at: '13:30', appointments: [] },
                  { appointment_at: '13:45', appointments: [] },
                  { appointment_at: '14:00', appointments: [] },
                  { appointment_at: '14:15', appointments: [] },
                  { appointment_at: '14:30', appointments: [] },
                  { appointment_at: '14:45', appointments: [] },
                  { appointment_at: '15:00', appointments: [] },
                  { appointment_at: '15:15', appointments: [] },
                  { appointment_at: '15:30', appointments: [] },
                  { appointment_at: '15:45', appointments: [] },
                  { appointment_at: '16:00', appointments: [] },
                  { appointment_at: '16:15', appointments: [] },
                  { appointment_at: '16:30', appointments: [] },
                  { appointment_at: '16:45', appointments: [] },
                  { appointment_at: '17:00', appointments: [] },
                  { appointment_at: '17:15', appointments: [] },
                  { appointment_at: '17:30', appointments: [] },
                  { appointment_at: '17:45', appointments: [] },
                  { appointment_at: '18:00', appointments: [] },
                  { appointment_at: '18:15', appointments: [] },
                  { appointment_at: '18:30', appointments: [] },
                  { appointment_at: '18:45', appointments: [] },
                ]})*/
            }

            console.log("ALL Appointments");

            console.log(all_appointments);


            console.log("PARAMS IN FETCH");
            console.log(params);
            let table_data1 = { /*'09:00': 0, '09:30': 1, '10:00': 2, '10:30': 3,'11:00': 4,  '11:30': 5, '12:00': 6, '12:30': 7*/
                '09:00': 0,
                '09:15': 1,
                '09:30': 2,
                '09:45': 3,
                '10:00': 4,
                '10:15': 5,
                '10:30': 6,
                '10:45': 7,
                '11:00': 8,
                '11:15': 9,
                '11:30': 10,
                '11:45': 11,
                '12:00': 12,
                '12:15': 13,
                '12:30': 14,
                '12:45': 15,
                '13:00': 16,
                '13:15': 17,
                '13:30': 18,
                '13:45': 19,
                '14:00': 20,
                '14:15': 21,
                '14:30': 22,
                '14:45': 23,
                '15:00': 24,
                '15:15': 25,
                '15:30': 26,
                '15:45': 27,
                '16:00': 28,
                '16:15': 29,
                '16:30': 30,
                '16:45': 31,
                '17:00': 32,
                '17:15': 33,
                '17:30': 34,
                '17:45': 35,
                '18:00': 36,
                '18:15': 37,
                '18:30': 38,
                '18:45': 39,
            }
            console.log(data);
            setLoadingList(false);
            let current_date = ""
            let all_days = []
            let day_data = undefined

            data.results.forEach((element) => {
                current_date = moment(element.appointment_at).format("YYYY-MM-DD")
                const current_hour = moment(element.appointment_at).format('HH:mm')
                let fecha = Object.keys(all_appointments).find(key => {
                    return all_appointments[key].hasOwnProperty(current_date)
                });
                console.log("********************");
                console.log(current_date);
                console.log(current_hour);
                console.log(all_appointments);
                console.log("********************");
                if (all_appointments[fecha][current_date][current_hour])
                    all_appointments[fecha][current_date][current_hour].push(element);
            })

            /*data.results.forEach( (element) => {
              const k = moment(element.appointment_at)
              // let day_data = {}
              if (current_date === ""){

                current_date = k.format("YYYY-MM-DD")
                console.log("New date. it was empty " + current_date);
                day_data = { [current_date]: [
                { appointment_at: '09:00', appointments: [] },
                { appointment_at: '09:15', appointments: [] },
                { appointment_at: '09:30', appointments: [] },
                { appointment_at: '09:45', appointments: [] },
                { appointment_at: '10:00', appointments: [] },
                { appointment_at: '10:15', appointments: [] },
                { appointment_at: '10:30', appointments: [] },
                { appointment_at: '10:45', appointments: [] },
                { appointment_at: '11:00', appointments: [] },
                { appointment_at: '11:15', appointments: [] },
                { appointment_at: '11:30', appointments: [] },
                { appointment_at: '11:45', appointments: [] },
                { appointment_at: '12:00', appointments: [] },
                { appointment_at: '12:15', appointments: [] },
                { appointment_at: '12:30', appointments: [] },
                { appointment_at: '12:45', appointments: [] },
                { appointment_at: '13:00', appointments: [] },
                { appointment_at: '13:15', appointments: [] },
                { appointment_at: '13:30', appointments: [] },
                { appointment_at: '13:45', appointments: [] },
                { appointment_at: '14:00', appointments: [] },
                { appointment_at: '14:15', appointments: [] },
                { appointment_at: '14:30', appointments: [] },
                { appointment_at: '14:45', appointments: [] },
                { appointment_at: '15:00', appointments: [] },
                { appointment_at: '15:15', appointments: [] },
                { appointment_at: '15:30', appointments: [] },
                { appointment_at: '15:45', appointments: [] },
                { appointment_at: '16:00', appointments: [] },
                { appointment_at: '16:15', appointments: [] },
                { appointment_at: '16:30', appointments: [] },
                { appointment_at: '16:45', appointments: [] },
                { appointment_at: '17:00', appointments: [] },
                { appointment_at: '17:15', appointments: [] },
                { appointment_at: '17:30', appointments: [] },
                { appointment_at: '17:45', appointments: [] },
                { appointment_at: '18:00', appointments: [] },
                { appointment_at: '18:15', appointments: [] },
                { appointment_at: '18:30', appointments: [] },
                { appointment_at: '18:45', appointments: [] },
                ]}
              }
              else{
                if (current_date !== k.format("YYYY-MM-DD")){
                  console.log("New date. it was not empty. Previous " + current_date );
                  current_date = k.format("YYYY-MM-DD")
                  day_data = { [current_date]: [
                    { appointment_at: '09:00', appointments: [] },
                { appointment_at: '09:15', appointments: [] },
                { appointment_at: '09:30', appointments: [] },
                { appointment_at: '09:45', appointments: [] },
                { appointment_at: '10:00', appointments: [] },
                { appointment_at: '10:15', appointments: [] },
                { appointment_at: '10:30', appointments: [] },
                { appointment_at: '10:45', appointments: [] },
                { appointment_at: '11:00', appointments: [] },
                { appointment_at: '11:15', appointments: [] },
                { appointment_at: '11:30', appointments: [] },
                { appointment_at: '11:45', appointments: [] },
                { appointment_at: '12:00', appointments: [] },
                { appointment_at: '12:15', appointments: [] },
                { appointment_at: '12:30', appointments: [] },
                { appointment_at: '12:45', appointments: [] },
                { appointment_at: '13:00', appointments: [] },
                { appointment_at: '13:15', appointments: [] },
                { appointment_at: '13:30', appointments: [] },
                { appointment_at: '13:45', appointments: [] },
                { appointment_at: '14:00', appointments: [] },
                { appointment_at: '14:15', appointments: [] },
                { appointment_at: '14:30', appointments: [] },
                { appointment_at: '14:45', appointments: [] },
                { appointment_at: '15:00', appointments: [] },
                { appointment_at: '15:15', appointments: [] },
                { appointment_at: '15:30', appointments: [] },
                { appointment_at: '15:45', appointments: [] },
                { appointment_at: '16:00', appointments: [] },
                { appointment_at: '16:15', appointments: [] },
                { appointment_at: '16:30', appointments: [] },
                { appointment_at: '16:45', appointments: [] },
                { appointment_at: '17:00', appointments: [] },
                { appointment_at: '17:15', appointments: [] },
                { appointment_at: '17:30', appointments: [] },
                { appointment_at: '17:45', appointments: [] },
                { appointment_at: '18:00', appointments: [] },
                { appointment_at: '18:15', appointments: [] },
                { appointment_at: '18:30', appointments: [] },
                { appointment_at: '18:45', appointments: [] },
                  ]}
                }
              }

              let fecha = Object.keys(all_appointments).find( key => {
                //console.log("In find");
                return all_appointments[key].hasOwnProperty(current_date)
              });

              // Hora
              let hour_in_table = Object.keys(all_appointments[fecha][k.format('YYYY-MM-DD')]).find( key => {
                //console.log("In find");
                return all_appointments[key].hasOwnProperty(current_date)
              });
              //console.log(all_appointments)
              //console.log(current_date)
              //console.log(fecha);
              //all_appointments.push(day_data)
              // day_data[current_date][table_data1[k.format('hhmm')]].appointments.push(element);
              //console.log(all_appointments[fecha]);
              console.log("********************");
              console.log(fecha);
              console.log(k.format('YYYY-MM-DD'));
              console.log(k.format('HH:mm'));
              console.log(table_data1[k.format('HH:mm')]);
              console.log("********************");

              //all_appointments[fecha][k.format('YYYY-MM-DD')][table_data1[k.format('HH:mm')]].appointments.push(element);
              all_appointments[fecha][k.format('YYYY-MM-DD')][k.format('HH:mm')].appointments.push(element);
            })
            */

            //setData(data.results)
            setAppointmentsData(all_appointments);
            //setAppointmentsData(['1', '2']);
            console.log("All appointmens final");

            console.log(all_appointments);

        }).catch((errorInfo) => {
            setLoading(false);
            if (errorInfo.status == 401) {
                sessionStorage.removeItem('token');
                sessionStorage.removeItem('user');
                history.push('/login');
            } else
                message.error(`Ha ocurrido un error al intentar obtener los turnos.\nStatus: ${errorInfo.status}\nDetalle: ${errorInfo.responseText}`);
        });
    };


    const handleExpand = () => {
        console.log("Expand!");
        setExpand(!expand);
    }

    const onChangeUploadSignatureFile = ({file, fileList, event}) => {
        console.log("CHANGED UPLOAD")
        console.log(data)
    }

    const uploadSignatureFile = (options) => {
        const {onSuccess, onError, file, onProgress} = options;
        console.log("UPLOAD")
        console.log(file)
        var formData = new FormData();
        var imagefile = file.name;
        formData.append("image", file);
        formData.append("id", form.getFieldValue('id'));
        axios.post(`${config.api_url}/profesionals/upload/`, formData, {
            headers: {
                'Authorization': `Token ${getToken()}`,
                'Content-Type': 'multipart/form-data'
            }
        }).then(data => {
            console.log("Success")
            onSuccess("Ok")
            // fetchProcedure(procedureForm.getFieldValue('id'))
            //
            // fetchProcedures({
            //     pagination: pagination,
            //     sortField: sortedInfo.field,
            //     sortOrder: sortedInfo.order,
            //     filters: filteredInfo
            // })
        }).catch(
             function(error){
                if (error.response) {
                    const errorInfo = error.response
                    if (errorInfo.status === 401) {
                        sessionStorage.removeItem('token');
                        sessionStorage.removeItem('user');
                        history.push('/login');
                    } else {
                        // setSaveButtonLoading(false);
                        const error_detail_txt = catchErrors(errorInfo);
                        onError({error_detail_txt})
                        // openErrorNotificacion(error_detail_txt)
                    }
                }
            });
    }

    return (
        <>

            <ConfigProvider locale={esES}>
                <Layout style={{minHeight: '100vh'}}>
                    <Sider collapsible collapsed={collapsed} onCollapse={onCollapse}>
                        <div className="logo"/>
                        <MyMenu active={active}/>
                    </Sider>
                    <Layout className="site-layout">
                        <Header/>
                        <Content style={{margin: '0 16px'}}>
                            <Breadcrumb style={{position: "relative", margin: '16px 0'}}>
                                <Breadcrumb.Item>Home</Breadcrumb.Item>
                                <Breadcrumb.Item>Profesionales</Breadcrumb.Item>
                            </Breadcrumb>

                            <div>
                                <Search className="site-search-button-wrapper" allowClear style={{width: '15%'}}
                                        placeholder="Busqueda rapida" onSearch={onFastSearch} enterButton/>
                            </div>
                            <div>
                                <Button type="primary" onClick={showDrawerCreate}>
                                    <PlusOutlined/> Nuevo Profesional
                                </Button>
                            </div>
                            <Table
                                showSizeChanger
                                columns={columns}
                                rowKey={record => record.id}
                                onRow={(record, rowIndex) => {
                                    return {
                                        onClick: event => {
                                            showDrawer(record.id)
                                        },
                                    };
                                }}
                                dataSource={data}
                                pagination={pagination}
                                loading={loading}
                                onChange={handleTableChange}
                            />
                            <Drawer
                                title="Profesional"
                                width={"65%"}
                                onClose={onClose}
                                visible={visible}
                                bodyStyle={{paddingBottom: 80}}
                                footer={
                                    <div
                                        style={{
                                            textAlign: 'right',
                                        }}
                                    >
                                        <Button onClick={onClose} style={{marginRight: 8}}>
                                            Cancelar
                                        </Button>
                                        <Button onClick={onSave} type="primary" loading={loadingSaveButton}>
                                            Guardar
                                        </Button>
                                    </div>
                                }
                            >
                                <Spin spinning={spinning}>
                                    <Form
                                        key={currentProfId || 'new'}
                                        form={form}
                                        layout="vertical" hideRequiredMark
                                    >
                                        <Tabs defaultActiveKey="1">
                                            <TabPane tab="Datos Personales" key="1">
                                                <Row gutter={4}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="verified"
                                                            valuePropName="checked"
                                                        >
                                                            <Checkbox
                                                                defaultChecked={formData.verified}>Revisado</Checkbox>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>

                                                <Row gutter={12}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="speciality"
                                                            label="Especialidad"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione una especialidad'
                                                            }]}
                                                        >
                                                            <Select
                                                                placeholder="Por favor seleccione un tipo"
                                                                defaultValue={formData.pacient_type}>
                                                                <Option value="PS">Psicología</Option>
                                                                <Option value="PQ">Psiquiatría</Option>
                                                                <Option value="EN">Enfermería</Option>
                                                                <Option value="TE">Terapista</Option>
                                                                <Option value="ME">Médico</Option>
                                                                <Option value="MG">Médico de Guardia</Option>
                                                                <Option value="KI">Kinesiología</Option>
                                                                <Option value="TO">Terapia Ocupacional</Option>
                                                                <Option value="MU">Musicoterapia</Option>
                                                                <Option value="NU">Nutrición</Option>
                                                                <Option value="TS">Trabajo Social</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="status"
                                                            label="Estado"
                                                            rules={[{
                                                                required: true,
                                                                message: 'Por favor seleccione un estado'
                                                            }]}
                                                        >
                                                            <Select
                                                                onChange={onStatuChange}
                                                                placeholder="Por favor seleccione un estado"
                                                                defaultValue={formData.status}>
                                                                <Option value="A">Activo</Option>
                                                                <Option value="I">Inactivo</Option>
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Datos Personales</Divider>
                                                <Row gutter={16}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="name"
                                                            label="Nombre"
                                                            initialValue={formData.name}
                                                            rules={[{required: true, message: 'Ingrese un nombre'}]}
                                                        >
                                                            <Input placeholder="Ingrese un nombre"/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="id"
                                                            label="id"
                                                            hidden
                                                        >
                                                            <Input hidden defaultValue={formData.id}/>
                                                        </Form.Item>

                                                        <Form.Item
                                                            name="last_name"
                                                            label="Apellido"
                                                            rules={[{required: true, message: 'Ingrese un apellido'}]}
                                                        >
                                                            <Input placeholder="Ingrese un apellido"
                                                                   defaultValue={formData.last_name}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8}>
                                                        <Form.Item
                                                            name="user"
                                                            label="Usuario del sistema"
                                                            extra="Asigne el usuario con el que este profesional inicia sesión."
                                                        >
                                                            <Select
                                                                allowClear
                                                                showSearch
                                                                placeholder="Seleccione un usuario"
                                                                filterOption={false}
                                                                notFoundContent={fetchingUsers ? 'Cargando...' : 'Sin resultados'}
                                                                onSearch={value => fetchUsers(value)}
                                                            >
                                                                {users.map(u => (
                                                                    <Option key={u.value} value={u.value}>{u.text}</Option>
                                                                ))}
                                                            </Select>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Row gutter={16}>
                                                    <Col span={4}>
                                                        <Form.Item
                                                            name="matricula"
                                                            label="Matricula"
                                                            rules={[{required: true, message: 'Ingrese una matricula'}]}
                                                        >
                                                            <Input placeholder="Ingrese una matricula"
                                                                   defaultValue={formData.matricula}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Contacto</Divider>
                                                <Row gutter={15}>
                                                    <Col span={5}>
                                                        <Form.Item
                                                            name="email"
                                                            label="Email"
                                                            rules={[{
                                                                type: 'email',
                                                                message: 'Ingrese un email valido',
                                                            },
                                                            ]}
                                                        >
                                                            <Input placeholder="Ingrese un email"
                                                                   defaultValue={formData.email}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="phone"
                                                            label="Telefono"
                                                            rules={[{required: true, message: 'Ingrese un telefono'}]}
                                                        >
                                                            <Input placeholder="Ingrese un telefono"
                                                                   defaultValue={formData.phone}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Honorarios</Divider>
                                                <Row gutter={15}>
                                                    <Col span={5}>
                                                        <Form.Item
                                                            name="appointment_price"
                                                            label="Costo Turno"
                                                        >
                                                            <InputNumber placeholder="Ingrese el costo del turno"
                                                                         defaultValue={formData.appointment_price}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={5}>
                                                        <Form.Item
                                                            name="over_shift_price"
                                                            label="Costo Sobreturno"
                                                        >
                                                            <InputNumber placeholder="Ingrese el costo del sobreturno"
                                                                         defaultValue={formData.over_shift_price}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Domicilio</Divider>
                                                <Row>
                                                    <Col span={24}>
                                                        <Checkbox checked={useMap} onChange={(e) => { const checked = e.target.checked; setUseMap(checked); if (checked) { showChildrenDrawer(); } else { onChildrenDrawerClose(); } }}>Geolocalizar con mapa</Checkbox>
                                                    </Col>
                                                </Row>
                                                <Row gutter={12}>
                                                    <Col span={10}>
                                                        <Form.Item
                                                            name="address"
                                                            label="Domicilio"
                                                            initialValue={formData.address}
                                                        >
                                                            <Input placeholder="Ingrese un calle"
                                                                   onFocus={useMap ? showChildrenDrawer : undefined} readOnly={useMap}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="floor"
                                                            label="Piso y dto"
                                                        >
                                                            <Input placeholder="ej. 1 A" defaultValue={formData.floor}/>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={3}>
                                                        <Form.Item
                                                            name="comuna"
                                                            label="Comuna"
                                                        >
                                                            <Input defaultValue={formData.comuna} readOnly={useMap}/>
                                                        </Form.Item>
                                                    </Col>
                                                </Row>
                                                <Divider orientation="left">Firma</Divider>
                                                <Row>
                                                    <Upload customRequest={uploadSignatureFile}
                                                            accept={'jpeg'}
                                                            onChange={onChangeUploadSignatureFile}
                                                            key={form.getFieldValue('id')}
                                                    >
                                                        <Button icon={<UploadOutlined/>} disabled={disbleUpload}>Subir
                                                            Firma</Button>
                                                    </Upload>
                                                </Row>
                                            </TabPane>
                                        </Tabs>
                                    </Form>
                                </Spin>
                                <Drawer
                                    title="Domicilio"
                                    width={640}
                                    closable={false}
                                    onClose={onChildrenDrawerClose}
                                    visible={childrenDrawer}
                                    footer={
                                        <div
                                            style={{
                                                textAlign: 'right',
                                            }}
                                        >
                                            <Button style={{textAlign: "right", marginRight: 8, marginTop: "16px"}}
                                                    onClick={onChildrenDrawerClose}>Cancelar</Button>
                                            <Button style={{textAlign: "right", marginRight: 8, marginTop: "16px"}}
                                                    type="primary" disabled={disabled}
                                                    onClick={onConfirmAddress}>Confirmar</Button>
                                        </div>
                                    }

                                >
                                    <LoadScript
                                        libraries={["places"]}
                                        googleMapsApiKey='AIzaSyDviwi-z9JT6JXJ9QSu-ZwY4ZHst40D9s8'>
                                        <GoogleMap
                                            mapContainerStyle={mapStyles}
                                            zoom={zoom}
                                            center={currentPosition}
                                            clickableIcons={false}
                                            options={{'disableDefaultUI': true}}
                                        >
                                            <Autocomplete
                                                onLoad={onLoad}
                                                onPlaceChanged={onPlaceChanged}
                                            >
                                                <input
                                                    type="text"
                                                    placeholder="Ingrese el domicilio sin piso ni dto"
                                                    style={{
                                                        textAlign: `center`,
                                                        boxSizing: `border-box`,
                                                        border: `1px solid transparent`,
                                                        width: `70%`,
                                                        height: `32px`,
                                                        padding: `0 12px`,
                                                        borderRadius: `3px`,
                                                        boxShadow: `0 2px 6px rgba(0, 0, 0, 0.3)`,
                                                        fontSize: `14px`,
                                                        outline: `none`,
                                                        textOverflow: `ellipses`,
                                                        position: "absolute",
                                                        left: "50%",
                                                        marginLeft: "-180px"
                                                    }}
                                                />
                                            </Autocomplete>
                                            <Marker position={currentPosition}/>
                                        </GoogleMap>
                                    </LoadScript>
                                </Drawer>
                            </Drawer>
                        </Content>
                    </Layout>
                </Layout>
            </ConfigProvider>
        </>
    );

}

export default Profesionals;
